import { CompanyIcon1 } from "../icons/CompanyIcon1";
import { CompanyIconText } from "./CompanyIconText/CompanyIconText";
import Input from "./Inputs/Input";

export default function Company({ errors, register }) {
  return (
    <>
      <div className="icon-text-wrapper">
        <CompanyIconText
          className="design-component-instance-node"
          icon={<CompanyIcon1 className="podjetje-icon" />}
        />
      </div>

      <Input
        label="Naziv podjetja"
        required={true}
        inputType="text"
        id="companyName"
        name="companyName"
        placeholder="Naziv podjetja"
        error={errors.companyName?.message}
        register={register}
      />

      <Input
        label="Zapis podjetja na priponki"
        required={false}
        inputType="text"
        id="companyLabel"
        name="companyLabel"
        placeholder="Zapis podjetja na priponki"
        maxLength={20}
        error={errors.companyLabel?.message}
        register={register}
      />

      <Input
        label="Naslov"
        labelClass="vertical-align"
        required={true}
        inputType="text"
        id="companyAddress"
        name="companyAddress"
        placeholder="Naslov"
        error={errors.companyAddress?.message}
        register={register}
      />

      <Input
        label="Pošta"
        labelClass="vertical-align"
        required={true}
        inputType="text"
        id="companyCity"
        name="companyCity"
        placeholder="Pošta"
        error={errors.companyCity?.message}
        register={register}
      />

      <Input
        label="Poštna številka"
        labelClass="vertical-align"
        required={true}
        inputType="text"
        id="companyZip"
        name="companyZip"
        placeholder="Poštna številka"
        error={errors.companyZip?.message}
        maxLength={8}
        register={register}
      />

      <Input
        label="Davčna številka"
        labelClass="vertical-align"
        required={true}
        inputType="text"
        id="vatId"
        name="vatId"
        placeholder="Davčna številka"
        error={errors.vatId?.message}
        maxLength={10}
        register={register}
      />
    </>
  );
}
